import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import rootReducer from './slices';
import { UserProvider } from './hooks'; // Import the UserProvider
import { CreateJobModalProvider } from './pages/DashboardProject/CreateJobModal';

export const store = configureStore({ 
  reducer: rootReducer, 
  devTools: true,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['loginSuccess', 'registerUserSuccessful', 'setContractor'],
        // Ignore these field paths in all actions
        ignoredActionsPaths: ['payload.user', 'payload._delegate', 'payload.multiFactor'],
        // Ignore these paths in the state
        ignoredPaths: ['Account.user', 'Login.user', 'Contractor.contractor']
      }
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY || ''}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <UserProvider>
        <CreateJobModalProvider>
          <App />
        </CreateJobModalProvider>
      </UserProvider>
    </GoogleReCaptchaProvider>
  </Provider>
);

reportWebVitals();